import {ThemeOptions} from '@mui/material';

const twoTheme: ThemeOptions = {
    palette: {
        primary: {
            main: '#227C9D',
            contrastText: '#FEF9EF',
        },
        secondary: {
            main: '#17C3B2',
        },
        warning: {
            main: '#FFCB77',
        },
        error: {
            main: '#FE6D73',
        },
        common: {
            white: '#FEF9EF',
        },
    },
};

export default twoTheme;
